
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';

/**
 * En varningsikon som används som overlay till aktiviteter
 */
const ProcessWarningOverlay: React.FunctionComponent<
  React.PropsWithChildren<{}>
> = () => <EDIcon iconType="warning" color="error" />;

export default ProcessWarningOverlay;
